<script>
import baseMixin from '@mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheDrawerMinifier',
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
    }),
  },
  methods: {
    ...mapActions({
      toggleMiniDrawer: 'toggleDrawer',
    }),
  },
}
</script>

<template>
  <div>
    <v-divider class="opacity-6"></v-divider>
    <div
      :class="[mini ? 'd-flex flex-column-reverse' : 'd-flex flex-row-reverse']"
    >
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            id="open-navbar-toggler-icon"
            class="navbar-toggler-icon pa-7"
            tile
            width="20%"
            icon
            active-class=""
            v-bind="attrs"
            @click.stop="toggleMiniDrawer"
            v-on="on"
          >
            <v-icon
              v-text="
                !mini ? 'mdi-chevron-double-left' : 'mdi-chevron-double-right'
              "
            ></v-icon>
          </v-btn>
        </template>
        <span
          v-text="
            !mini
              ? $t('layout.drawerMinifierOpenTooltipText')
              : $t('layout.drawerMinifierClosedTooltipText')
          "
        ></span>
      </v-tooltip>

      <v-tooltip :disabled="!mini" right>
        <template v-slot:activator="{ on }">
          <v-btn
            class="pa-7"
            width="80%"
            text
            tile
            elevation="0"
            v-on="on"
            @click="$router.push({ name: 'settings' })"
          >
            <v-icon left> mdi-cog </v-icon>
            <span v-if="!mini"> {{ $t('settings.pageTitle') }} </span>
          </v-btn>
        </template>
        <span>{{ $t('settings.pageTitle') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>
